export default __webpack_public_path__ + "static/media/detail-iv-audio-thumbnail@2x.438297a6.png";